export const SUPPORT_EMAIL = 'support@petmarketscout.com';
export const BRAND_NAME = 'Pet Market Scout';

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong';
export const DEFAULT_ERROR_DESCRIPTION =
  'We are having some issues. Please try again later.';
